<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="用户名称：">
                    <el-input v-model.trim="formInline.name" maxlength="60" clearable placeholder="用户名称" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="用户账号：">
                    <el-input v-model.trim="formInline.username" maxlength="60" clearable placeholder="用户账号" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="formInline.is_active" placeholder="请选择" clearable style="width: 120px" @change="search">
                        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button v-if="hasPermission('manage_subaccount')" icon="Plus" @click="addSubAccount" type="success">新增子账号</el-button></el-form-item>
            </el-form>
        </div>

        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" prop="name" label="用户名称"></el-table-column>
                <el-table-column min-width="150" prop="username" label="用户账号"></el-table-column>
                <el-table-column min-width="100" label="状态">
                    <template #default="scope">
                        <el-tag v-if="scope.row.is_active">正常</el-tag>
                        <el-tag v-else type="danger">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column min-width="150" prop="create_datetime" label="创建时间"></el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template #default="scope">
                        <el-button v-if="hasPermission('manage_subaccount')" link type="primary" @click="handleEdit(scope.row,'edit')" icon="Edit"></el-button>
                        <el-button v-if="hasPermission('manage_subaccount')" link type="danger" @click="handleEdit(scope.row,'delete')" icon="Delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <add-sub-account ref="addSubAccountFlag" @refreshData="getData"></add-sub-account>
    </div>
</template>
<script>
    import addSubAccount from "./components/addSubAccount";
    import Pagination from "@/components/Pagination";
    import {getTableHeight} from "@/utils/util";
    import {apiPartnerSubAccount, apiPartnerSubAccountDelete} from '@/api/api'
    import { hasPermission } from '@/utils/permission'
    export default {
        components:{
            Pagination,
            addSubAccount
        },
        name:'subAccountManage',
        data() {
            return {
                isFull:false,
                tableHeight:500,
                loadingPage:false,
                formInline:{
                    page: 1,
                    limit: 20,
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                statusList:[
                    {id:1,name:'正常'},
                    {id:0,name:'禁用'}
                ],
                tableData:[],
            }
        },
        methods:{
            hasPermission,
            getIndex($index) {
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            addSubAccount() {
                this.$refs.addSubAccountFlag.addSubAccountFn(null,'新增')
            },
            handleEdit(row,flag) {
                if(flag=='edit') {
                    this.$refs.addSubAccountFlag.addSubAccountFn(row,'编辑')
                }
                else if(flag=='delete') {
                    let vm = this
                    vm.$confirm('您确定要删除选中的子账号？',{
                        closeOnClickModal:false
                    }).then(res=>{
                        apiPartnerSubAccountDelete({id:row.id}).then(res=>{
                            if(res.code == 2000) {
                                vm.$message.success(res.msg)
                                vm.search()
                            } else {
                                vm.$message.warning(res.msg)
                            }
                        })
                    }).catch(()=>{})
                }
                else if(flag=="reset"){
                    this.formInline = {
                        page:1,
                        limit: 20
                    }
                    this.pageparm={
                        page: 1,
                        limit: 20,
                        total: 0
                    }
                    this.getData()
                }
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
            },
            async getData(){
                this.loadingPage = true
                apiPartnerSubAccount(this.formInline).then(res => {
                    this.loadingPage = false
                    if(res.code ==2000) {
                        this.tableData = res.data.data
                        this.pageparm.page = res.data.page;
                        this.pageparm.limit = res.data.limit;
                        this.pageparm.total = res.data.total;
                    }
                })
            },
            listenResize() {
                this.$nextTick(() => {
                    this.getTheTableHeight()
                })
            },
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight = getTableHeight(tabSelectHeight)
            }
        },
        created() {
            this.getData()
        },
        mounted() {
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },
        unmounted() {
            window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
